import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LANDING_LINKS } from '@/config/landing-links';
import tracerImg from '@/assets/images/tracer.svg';

import footerStyles from '../../LandingFooter.module.sass';
import styles from './FooterProducts.module.sass';

export const FooterProducts = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.group}>
        <div className={footerStyles.title}>
          {t('translation.landingFooter.forBusiness')}
        </div>
        <ul className={footerStyles.list}>
          <li>
            <Link
              to={LANDING_LINKS.TRANSACTION_MONITORING_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.transactionMonitoring')}
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.B2B_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.kyt')}
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.KYC_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.kyc')}
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.TRACER_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              <span>AMLBot</span>
              <img src={tracerImg} alt="Tracer" className={styles.tracer} />
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.TRAINING_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.amlTraining')}
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.CONSULTING_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.consulting')}
            </Link>
          </li>
        </ul>
      </div>

      <div className={styles.group}>
        <div className={footerStyles.title}>
          {t('translation.landingFooter.forPersonalUse')}
        </div>
        <ul className={footerStyles.list}>
          <li>
            <Link
              to={LANDING_LINKS.CRYPTO_CHECKER_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.amlChatBot')}
            </Link>
          </li>

          <li>
            <Link
              to={LANDING_LINKS.INVESTIGATION_PAGE_URL}
              rel="noreferrer nofollow"
              target="_blank"
              className={footerStyles.link}
            >
              {t('translation.landingFooter.investigation')}
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};
